import { PATH } from "constants/path";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ children }: { children?: React.ReactNode }) => {
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("password");

  const isAuthenticated = !!username || !!token;

  if (!isAuthenticated) return <Navigate to={PATH.Home} />;

  return <>{children || <Outlet />}</>;
};

export default ProtectedRoute;
